import type { ReactNode } from 'react';

export const symbol_google_home_devices: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M322-207H132q-24 0-42-18.5T72-268v-512q0-24 18-42t42-18h680q24 0 42 18t18 42v125h-60v-125H132v513h348v147H352q-12.75 0-21.37-8.63Q322-137.25 322-150v-57Zm326.88-150q26.88-27 65-27Q752-384 779-357.12q27 26.88 27 65Q806-254 779.12-227q-26.88 27-65 27Q676-200 649-226.88q-27-26.88-27-65Q622-330 648.88-357Zm198.88-268Q864-625 876-613t12 28.39v424.22Q888-144 876-132t-28.24 12H580.24Q564-120 552-132t-12-28.39v-424.22Q540-601 552-613t28.24-12h267.52ZM672-568q-18 18-18 42t18 42q18 18 42 18t42-18q18-18 18-42t-18-42q-18-18-42-18t-42 18Zm138.5 372.5Q848-233 848-292t-37.5-96.5Q773-426 714-426t-96.5 37.5Q580-351 580-292t37.5 96.5Q655-158 714-158t96.5-37.5Z"
		/>
	</svg>
);
